import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconActivity = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    viewBox="0 0 22 22"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.8}
      d="M2.25 7.25C1.547 7.25 1 6.625 1 6c0-.664.547-1.25 1.25-1.25h12.46V1.937c0-.351.235-.703.587-.859.351-.117.742-.078 1.015.195l4.375 4.063c.391.351.391 1.016 0 1.367l-4.375 4.063c-.273.273-.664.312-1.015.156-.352-.117-.586-.469-.586-.86V7.25H2.25Zm17.5 7.5c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25H7.25v2.813c0 .39-.234.742-.586.859-.351.156-.742.117-1.016-.156l-4.375-4.063c-.39-.351-.39-1.015 0-1.367l4.375-4.063c.274-.273.665-.312 1.016-.195.352.117.586.469.586.86v2.812h12.5Z"
    />
  </svg>
));
export default SvgIconActivity;
